import { LyStyleTheme } from 'alyle-ui/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyToolbar, ToolbarItem } from './toolbar';
var LyToolbarModule = /** @class */ (function () {
    function LyToolbarModule() {
    }
    LyToolbarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    exports: [LyToolbar, ToolbarItem],
                    declarations: [LyToolbar, ToolbarItem],
                    providers: [LyStyleTheme]
                },] },
    ];
    /** @nocollapse */
    LyToolbarModule.ctorParameters = function () { return []; };
    return LyToolbarModule;
}());
export { LyToolbarModule };
//# sourceMappingURL=toolbar.module.js.map